import { render, staticRenderFns } from "./SnackbarGlobal.vue?vue&type=template&id=405d7f9e&lang=pug&"
import script from "./SnackbarGlobal.vue?vue&type=script&lang=js&"
export * from "./SnackbarGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VSnackbar})
